import _ from 'lodash'
import {buildQuery, filterKeys} from './query_matching'
import {createCollectionLike, getIndexedCandidates, getRecordsFromIdIndex} from './indexed_records'

export const findRecord = (entities, query) => {
	if (!_.isObject(query)) {
		const id = Number(query)
		return entities.find(e => e.id == id)
	}
	const {keys, sanitizedQuery, hasOnlyUndefinedValues} = buildQuery(query)
	if (hasOnlyUndefinedValues) return

	return entities.find(e => {
		return filterKeys(keys, sanitizedQuery, e)
	})
}

export const filterRecords = (entities, query) => {
	if (_.isArray(query)) return getRecordsFromIdIndex(entities, query)
	if (_.isNumber(query)) return getRecordsFromIdIndex(entities, [query])

	const {keys, sanitizedQuery, hasOnlyUndefinedValues} = buildQuery(query)
	if (hasOnlyUndefinedValues) return createCollectionLike(entities, [])

	const candidates = getIndexedCandidates(entities, keys, sanitizedQuery) || entities

	return candidates.filter(e => {
		return filterKeys(keys, sanitizedQuery, e)
	})
}

export const inverseFilterRecords = (entities, query) => {
	const {keys, sanitizedQuery, hasOnlyUndefinedValues} = buildQuery(query)
	if (hasOnlyUndefinedValues) return createCollectionLike(entities, [])

	return entities.filter(e => {
		return !filterKeys(keys, sanitizedQuery, e)
	})
}
